import envConfig from '@acre/config'

import createAxiosInstance from '../utils/createAxiosInstance'

const axiosInstance = createAxiosInstance(
  {
    baseURL: `${envConfig.API1_URL}/acre`,
  },
  {
    useApiKey: true,
    useLutherInterceptor: true,
  },
)

export default axiosInstance
